<div class="flex flex-column gap-2">
  <div class="basis-1/2">
    <nx-table-header class="text-[1rem]" [label]=" 'coreModuleModule.subscriptionsComponent.list.headline' | translate ">
      <ng-template nxTemplate="end">
        <nx-default-button
          (click)="createSubscription()"
          [style]="'light'"
          [label]="'coreModuleModule.subscriptionsComponent.list.addSubscription' | translate"
          [icon]="'icon-plus'">
        </nx-default-button>
        <!-- <nx-default-button (click)="refetchEvents()" [style]="'light'" [label]="'Aktualisieren'"
          [icon]="'icon-refresh'">
        </nx-default-button> -->
      </ng-template>
    </nx-table-header>
    <p-table #httpLogTable [lazy]="true" (onLazyLoad)="loadData($event)" [value]="dataSource?.data" [scrollable]="true"
      [paginator]="true" [rows]="15" selectionMode="single" 
      [(selection)]=dataSource.selectedEventSubscription
      dataKey="id" 
      (onRowSelect)="setMenuItems()"
      [rowsPerPageOptions]="[15, 20, 50]" [totalRecords]="dataSource?.totalElements" [loading]="loading"
      [sortField]="sortProperty" [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
      [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} von {totalRecords}"
      [resizableColumns]="true">
      <ng-template pTemplate="caption">
        <div class="flex flex-row">
          <div class="basis-2/3 flex flex-row gap-2">
            <!-- no filter -->
          </div>
          <div class="basis-1/3 flex flex-row justify-end">
            <p-dropdown placeholder="Sortierung" [styleClass]="'sort'" appendTo="body" [ngModel]="sortModel"
              [options]="sortOptions | translateLabels" optionLabel="label" [showClear]="false" (onChange)="sort($event)">
            </p-dropdown>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="min-width: 3rem; width: 3rem;">{{ 'coreModuleModule.subscriptionsComponent.list.table.headlines.id' | translate }}</th>
          <th style="min-width: 5rem; width: 8rem;"></th>
          <th style="min-width:9.813rem; width: 9.813rem;">{{ 'coreModuleModule.subscriptionsComponent.list.table.headlines.lastTriggeredDateTime' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-subscription>
        <tr class="clickable" [pSelectableRow]="subscription">
          <td>
            {{subscription.id}}
          </td>
          <td>
            <p-tag 
              [value]="subscription?.active ? ('coreModuleModule.subscriptionsComponent.subscriptionIsActive' | translate) : ('coreModuleModule.subscriptionsComponent.subscriptionIsNotActive' | translate)"
              [severity]="subscription?.active ? 'success' : 'danger'">
            </p-tag>
          </td>
          <td>{{subscription?.lastTriggeredDateTime ? (subscription?.lastTriggeredDateTime | date:'dd.MM.YY HH:mm:ss') : '-'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="emptyMessage">{{'coreModuleModule.subscriptionsComponent.list.table.emptyMessage' | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
    </ng-template>
  </div>
  <div class="basis-1/2">
    <nx-headline-box
      [label]="'coreModuleModule.subscriptionsComponent.details.headline' | translate">
      <ng-template nxTemplate="end">
        <nx-default-button
          [menuItems]="menuItems"
          [menuWithIcon]="false"
          class="pt-1"
          [icon]="'icon-options'">
        </nx-default-button>
      </ng-template>
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.id' | translate">
      {{dataSource?.selectedEventSubscription?.id}}
      <ng-template
        nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedEventSubscription?.id"
          (click)="copyToClipboard(dataSource?.selectedEventSubscription?.id)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'coreModuleModule.subscriptionsComponent.details.copyToolTip' | translate">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.externalId' | translate">
      {{dataSource?.selectedEventSubscription?.externalId}}
      <ng-template
        nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedEventSubscription?.externalId"
          (click)="copyToClipboard(dataSource?.selectedEventSubscription?.externalId)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'coreModuleModule.subscriptionsComponent.details.copyToolTip' | translate">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Status'">
  <ng-container *ngIf="dataSource?.selectedEventSubscription; else noSubscriptionSelected">
    {{dataSource?.selectedEventSubscription?.active ? ('coreModuleModule.subscriptionsComponent.subscriptionIsActive' | translate) : ('coreModuleModule.subscriptionsComponent.subscriptionIsNotActive' | translate)}}
  </ng-container>
  <ng-template #noSubscriptionSelected>
    -
  </ng-template>
    </nx-default-box>
    <!-- <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Typ'">
      {{dataSource?.selectedEventSubscription?.type}}
    </nx-default-box> -->
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.url' | translate">
      {{dataSource?.selectedEventSubscription?.url}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.eventTypes' | translate">
      {{dataSource?.selectedEventSubscription?.eventTypes?.length > 0 ? dataSource?.selectedEventSubscription?.eventTypes.join(', ') : '-'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.lastTriggeredDateTime' | translate">
      {{dataSource?.selectedEventSubscription?.lastTriggeredDateTime ? (dataSource?.selectedEventSubscription?.lastTriggeredDateTime | date:'dd.MM.YY HH:mm:ss') : '-'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.customHeaders' | translate">
      <div *ngIf="dataSource?.selectedEventSubscription?.customHeadersArray?.length > 0; else noCustomHeaders">
        <ul class="list-disc pl-5">
          <li *ngFor="let header of dataSource?.selectedEventSubscription?.customHeadersArray">
            {{header?.name}}: {{header?.value}}
          </li>
        </ul>
      </div>
      <ng-template #noCustomHeaders>
        -
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModuleModule.subscriptionsComponent.details.headlines.secret' | translate">
      {{ dataSource?.selectedEventSubscription?.secretHash ? '••••••••••••••••' : '-' }}
    </nx-default-box>

  </div>
</div>